import { media } from '../../../../utils/styles'
import styled from 'styled-components'

export const AlertContainer = styled.section`
  width: 100%;
  height: 88px;
  margin-bottom: 0;

  ${media.mobile`
    height: unset;
    margin-bottom: var(--spacing-size-2xs);
  `}
`
